export default __webpack_public_path__ + "static/media/check-circle_2.ad1ed9b8.svg";